import {
  LIST_CREDIT_LIMIT_REQUEST,
  LIST_CREDIT_LIMIT_SUCCESS,
  LIST_CREDIT_LIMIT_FAIL,
  DETAIL_CREDIT_LIMIT_REQUEST,
  DETAIL_CREDIT_LIMIT_SUCCESS,
  DETAIL_CREDIT_LIMIT_FAIL,
  CREATE_CREDIT_LIMIT_REQUEST,
  CREATE_CREDIT_LIMIT_SUCCESS,
  CREATE_CREDIT_LIMIT_FAIL,
  UPDATE_CREDIT_LIMIT_REQUEST,
  UPDATE_CREDIT_LIMIT_SUCCESS,
  UPDATE_CREDIT_LIMIT_FAIL,
  DELETE_CREDIT_LIMIT_REQUEST,
  DELETE_CREDIT_LIMIT_SUCCESS,
  DELETE_CREDIT_LIMIT_FAIL
} from '../../constants/manage-credit-limit'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingDetail: false,
  loadingDelete: false,
  creditLimits: [],
  creditLimitDetail: null,
  error: null,
  pageable: {
    page: 1,
    size: 10,
    hits: 0
  }
}

const manageCreditLimitReducer = (state = initialState, action) => {
  switch (action.type) {
    // List
    case LIST_CREDIT_LIMIT_REQUEST:
      return { ...state, loading: true }
    case LIST_CREDIT_LIMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        creditLimits: action.payload,
        pageable: action.pageable || state.pageable
      }
    case LIST_CREDIT_LIMIT_FAIL:
      return { ...state, loading: false, error: action.payload, creditLimits: [] }

    // Detail
    case DETAIL_CREDIT_LIMIT_REQUEST:
      return { ...state, loadingDetail: true, creditLimitDetail: null }
    case DETAIL_CREDIT_LIMIT_SUCCESS:
      return { ...state, loadingDetail: false, creditLimitDetail: action.payload }
    case DETAIL_CREDIT_LIMIT_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }

    // Create & Update
    case CREATE_CREDIT_LIMIT_REQUEST:
    case UPDATE_CREDIT_LIMIT_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_CREDIT_LIMIT_SUCCESS:
    case UPDATE_CREDIT_LIMIT_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_CREDIT_LIMIT_FAIL:
    case UPDATE_CREDIT_LIMIT_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }

    // Delete
    case DELETE_CREDIT_LIMIT_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_CREDIT_LIMIT_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_CREDIT_LIMIT_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }

    default:
      return state
  }
}

export default manageCreditLimitReducer
